import CrewTransferMenu from "../../../../components/pages/Management/CrewTransfer/CrewTransferMenu";
import Breadcrumbs from "../../../../components/shared/Breadcrumbs/Breadcrumbs";
import { PageContainer } from "../../../../styled";

const CrewTransfer = () => {
  return (
    <PageContainer>
      <Breadcrumbs border={false} />
      <CrewTransferMenu />
    </PageContainer>
  );
};
export default CrewTransfer;
